// [5.8.2026, 13:39:14] Änderung: Die Firestore-Konvertierung der Prioritäten wurde in die Hilfsfunktion `toPrio` ausgelagert. Fehlende oder unvollständige `priorityX`-Felder werden nun defensiv behandelt und mit `null` bzw. leerem Text vorbelegt.
// [16.4.2026, 08:09:28] Änderung:
//    Es wurde eine Eingabevalidierung ergänzt: Wenn `vacationPeriod` oder `userId` leer bzw. nur aus Leerzeichen bestehen, wird die Promise sofort mit einem Fehler abgelehnt.
//    Dadurch wird verhindert, dass die Datenbankabfrage mit ungültigen Parametern ausgeführt wird.
// [16.4.2026, 08:04:11] Änderung: Die Export-Funktion wurde von `GetVacationsData` in `GetUserVacationsData` umbenannt, die Rückgabe und Implementierung bleiben unverändert. Zusätzlich wurde am Dateianfang ein überflüssiges Sonderzeichen vor dem `import` entfernt.
import {db} from "@/main";
import {
    FirestoreDataConverter,
    collection,
    query,
    where,
    getDocs,
    setDoc,
    doc, getDoc
} from "firebase/firestore";

const vacationDataConverter: FirestoreDataConverter<VacationData> = {
    toFirestore(data: VacationData) {
        return data;
    },
    fromFirestore(snapshot) {
        const data = snapshot.data();
        // priorityX kann in aelteren/teilweise gespeicherten Dokumenten fehlen -> defensiv lesen
        const toPrio = (p: any) => ({
            startDate: p?.startDate?.toDate() ?? null,
            endDate: p?.endDate?.toDate() ?? null,
            bemerkung: p?.bemerkung ?? "",
        });
        return { ...data,
            priorityOne: toPrio(data.priorityOne),
            priorityTwo: toPrio(data.priorityTwo),
            priorityThree: toPrio(data.priorityThree),
            priorityFour: toPrio(data.priorityFour),
            } as VacationData;
    }
};

export function GetVacationData(vacationPeriod: string, userId:string): Promise<VacationData> {
    return new Promise<VacationData>(async (resolve, reject) => {
        try {
            if (!vacationPeriod.trim() || !userId.trim()) {
                reject(new Error("vacationPeriod und userId duerfen nicht leer sein."));
                return;
            }

            const vacationDataRef = collection(db, "vacationData").withConverter(vacationDataConverter);
            const vacationDataQuery = query(
                vacationDataRef,
                where("employNr", "==", userId),
                where("year", "==", vacationPeriod)
            );

            const vacationDataSnapshot = await getDocs(vacationDataQuery);

            if (!vacationDataSnapshot.empty) {
                resolve(vacationDataSnapshot.docs[0].data() as VacationData);
            } else {
                resolve({} as VacationData);
                //reject("No matching VacationData found!");
            }
        } catch (error) {
            reject(error);
        }
})}

export function GetUserVacationsData(userId:string | undefined): Promise<VacationData[]> {
    return new Promise<VacationData[]>(async (resolve, reject) => {
        try {
            const vacationDataRef = collection(db, "vacationData").withConverter(vacationDataConverter);
            const vacationDataQuery = query(
                vacationDataRef,
                where("employNr", "==", userId)
            );

            const vacationDataSnapshot = await getDocs(vacationDataQuery);

            if (!vacationDataSnapshot.empty) {

                const returnVacationData: VacationData[] = [];

                for (const vacationData of vacationDataSnapshot.docs) {
                    returnVacationData.push({...vacationData.data()} as VacationData);
                }

                resolve(returnVacationData);

            } else {
                reject("No matching vacationData found!");
            }
        } catch (error) {
            reject(error);
        }
    })}

export function InsertVacationData(vacationData: VacationData): Promise<void> {
    return new Promise<void>((resolve, reject) => {
        setDoc(doc(db, "vacationData", vacationData.id), {   
                id: vacationData.id,
                userId: vacationData.userId,
                finished: vacationData.finished,
                year: vacationData.year,
                employNr: vacationData.employNr,
                priorityOne: vacationData.priorityOne,
                priorityTwo: vacationData.priorityTwo,
                priorityThree: vacationData.priorityThree,
                priorityFour: vacationData.priorityFour,
                reliefDays: vacationData.reliefDays,
        }, { merge: true })
            .then(() => {
                resolve();
            })
            .catch((error) => {
                reject(error);
            });
    
})}